<template>
    <ds-modal
        data-qa="email-compliance-modal"
        is-open
        size="xs"
        @close="$emit('close')"
    >
        <h4 class="title">
            Email broadcast sending for this account has been disabled
        </h4>

        <p class="description">
            Due to a compliance or payment issue your ability to send email broadcasts has been disabled. Contact support for details on how to re-enable broadcast sending.
        </p>

        <div class="actions">
            <ds-text-button
                class="small"
                gray
                aria-label="Close"
                @click="$emit('close')"
            >
                Close
            </ds-text-button>

            <ds-text-button
                as="a"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Contact support"
                href="https://www.thryv.com/contact-us/"
            >
                Contact support
            </ds-text-button>
        </div>
    </ds-modal>
</template>

<script>
export default {
    name: 'EmailComplianceModal',
};
</script>

<style lang="scss" scoped>
    .title {
        font-weight: 600;
        line-height: $line-height-lg;
    }

    .description {
        padding-top: $spacing-200;
    }

    .actions {
        display: flex;
        justify-content: flex-end;
    }

</style>
